module.exports = __webpack_public_path__ + "images/avatar-david.ca908593a3368f94d114e23a289ab5a2.png";